enum ActionTypes {
  FETCH_EVENT_REASON_CATALOG_REQUEST = 'FETCH_EVENT_REASON_CATALOG_REQUEST',
  FETCH_EVENT_REASON_CATALOG_SUCCESS = 'FETCH_EVENT_REASON_CATALOG_SUCCESS',
  FETCH_EVENT_REASON_CATALOG_FAILURE = 'FETCH_EVENT_REASON_CATALOG_FAILURE',
  SET_EVENT_REASON_CATALOG = 'SET_EVENT_REASON_CATALOG',

  OPEN_EVENT_REASON_PROMPT = 'OPEN_EVENT_REASON_PROMPT',
  CLOSE_EVENT_REASON_PROMPT = 'CLOSE_EVENT_REASON_PROMPT',

  SUBMIT_EVENT_REASON_TAGGING = 'SUBMIT_EVENT_REASON_TAGGING',
  SKIP_EVENT_REASON_TAGGING = 'SKIP_EVENT_REASON_TAGGING',

  SET_PENDING_EVENT_REASON_TAGGING = 'SET_PENDING_EVENT_REASON_TAGGING',
  REMOVE_PENDING_EVENT_REASON_TAGGING = 'REMOVE_PENDING_EVENT_REASON_TAGGING',

  SET_PENDING_EVENT_REASON_PROMPT_SNOOZE = 'SET_PENDING_EVENT_REASON_PROMPT_SNOOZE',
  REMOVE_PENDING_EVENT_REASON_PROMPT_SNOOZE = 'REMOVE_PENDING_EVENT_REASON_PROMPT_SNOOZE'
}

export default ActionTypes;
